const MuiStepLabel = {
    iconContainer: {
      paddingRight: 0,
    },
  }
  
  export default MuiStepLabel
  